import { css } from "@emotion/react";
import { styleUtils } from "@minted/minted-components";
import React, { memo } from "react";

/**
 * Landscape media treatment — single photo constrained to the content
 * wrapper width (legacy l1 / Masthead image slot). Design theme does not
 * style this image; layout CSS only.
 */
const styles = {
  image: css`
    box-sizing: border-box;
    display: block;
    margin-bottom: ${styleUtils.rem(30)};
    width: 100%;
  `,
  // Mirrors fancyclothes Wrapper so landscape stays inset vs full-bleed.
  wrapper: css`
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    max-width: ${styleUtils.rem(1170)};
    padding-left: ${styleUtils.rem(15)};
    padding-right: ${styleUtils.rem(15)};
  `,
};

export type LandscapeMediaProps = {
  alt: string;
  headerSlotPosition: number;
  photoURL: string;
};

const LandscapeMedia = ({
  alt,
  headerSlotPosition,
  photoURL,
}: LandscapeMediaProps) => (
  <div css={styles.wrapper}>
    <img
      alt={alt}
      css={styles.image}
      data-cy="mainImage"
      data-slot-index={headerSlotPosition}
      src={photoURL}
    />
  </div>
);

const MemoizedLandscapeMedia = memo(LandscapeMedia);

export { MemoizedLandscapeMedia as LandscapeMedia };
